document.addEventListener('DOMContentLoaded', function() {
    const pauseButtons = document.querySelectorAll('.carousel-pause-btn');

    pauseButtons.forEach(button => {
        const carouselContainer = button.closest('.career');
        const pauseText = button.querySelector('.pause-text');
        const playText = button.querySelector('.play-text');

        button.addEventListener('click', function() {
            const currentState = button.getAttribute('data-carousel-state');

            if (currentState === 'playing') {
                // Pause le carrousel
                carouselContainer.classList.add('paused');
                button.setAttribute('data-carousel-state', 'paused');
                button.setAttribute('aria-label', 'Reprendre le carrousel d\'images');
                pauseText.classList.add('hidden');
                playText.classList.remove('hidden');
            } else {
                // Reprend le carrousel
                carouselContainer.classList.remove('paused');
                button.setAttribute('data-carousel-state', 'playing');
                button.setAttribute('aria-label', 'Mettre en pause le carrousel d\'images');
                pauseText.classList.remove('hidden');
                playText.classList.add('hidden');
            }
        });

        // Pause automatiquement si l'utilisateur navigue au clavier dans le carrousel
        carouselContainer.addEventListener('focusin', function(e) {
            if (e.target !== button && carouselContainer.contains(e.target)) {
                if (button.getAttribute('data-carousel-state') === 'playing') {
                    button.click(); // Déclenche la pause
                }
            }
        });
    });
});
